import { Prize } from '../models/SpinWheel';

// Interface for spin history records
export interface SpinHistoryRecord {
  id: string;
  userId: string;
  wheelId: string;
  wheelName: string;
  prizeId: string;
  prizeName: string;
  prizeImage: string;
  spinDate: string;
}

// This interface represents the API response format for spin wheel configurations
export interface SpinWheelConfig {
  id: string;
  name: string;
  description: string;
  centerImage: string;
  defaultSize: number;
  defaultSpinDuration: number;
  prizes: Prize[];
  createdAt: string;
  updatedAt: string;
  isActive: boolean;
}

// Mock data that would typically come from an API
const MOCK_SPIN_WHEEL_CONFIGS: SpinWheelConfig[] = [
  {
    id: 'wheel-001',
    name: 'POPWELL',
    description: 'Spin the wheel to win prizes!',
    centerImage: '/assets/images/spinwheel/logo.svg',
    defaultSize: 320,
    defaultSpinDuration: 5,
    prizes: [
      {
        id: 'prize-001',
        name: 'Hat',
        image: '/assets/images/spinwheel/hat.svg',
        probability: 0.2,
        backgroundColor: '#FF9F80'
      },
      {
        id: 'prize-002',
        name: 'Popsocket',
        image: '/assets/images/spinwheel/popsocket.svg',
        probability: 0.3,
        backgroundColor: '#80B3FF'
      },
      {
        id: 'prize-003',
        name: 'Coozy',
        image: '/assets/images/spinwheel/coozy.svg',
        probability: 0.2,
        backgroundColor: '#FF80AB'
      },
      {
        id: 'prize-004',
        name: 'NFT',
        image: '/assets/images/spinwheel/nft.svg',
        probability: 0.3,
        backgroundColor: '#80FFB0'
      }
    ],
    createdAt: '2025-05-01T00:00:00Z',
    updatedAt: '2025-05-15T00:00:00Z',
    isActive: true
  }
];

// Mock API service for SpinWheel
export class SpinWheelService {
  // Get all available wheel configurations
  public static async getWheelConfigurations(): Promise<SpinWheelConfig[]> {
    // Simulate API delay
    return new Promise(resolve => {
      setTimeout(() => {
        resolve(MOCK_SPIN_WHEEL_CONFIGS);
      }, 300);
    });
  }

  // Get specific wheel configuration by ID
  public static async getWheelConfigurationById(id: string): Promise<SpinWheelConfig | null> {
    // Simulate API delay
    return new Promise(resolve => {
      setTimeout(() => {
        const config = MOCK_SPIN_WHEEL_CONFIGS.find(config => config.id === id);
        resolve(config || null);
      }, 300);
    });
  }

  // Get active wheel configuration (in a real app, this might be determined by campaign, date, etc.)
  public static async getActiveWheelConfiguration(): Promise<SpinWheelConfig | null> {
    // Simulate API delay
    return new Promise(resolve => {
      setTimeout(() => {
        const activeConfig = MOCK_SPIN_WHEEL_CONFIGS.find(config => config.isActive);
        resolve(activeConfig || null);
      }, 300);
    });
  }

  // Record spin result (in a real app, this would send the result to a backend)
  public static async recordSpinResult(wheelId: string, prizeId: string, userId?: string): Promise<boolean> {
    // Simulate API delay and success
    return new Promise(resolve => {
      setTimeout(() => {
        console.log(`Recorded spin result: User ${userId || 'anonymous'} won prize ${prizeId} on wheel ${wheelId}`);
        resolve(true);
      }, 300);
    });
  }
}
